import React from 'react';
import './RightPanelSwitcher.css';

/**
 * Visible choices for the one right-hand slot (#2074).
 * Story progress opens the lane panel (#2075).
 * Story Dashboard is not a choice.
 */
export const RIGHT_SLOT_CHOICES = [
  { id: 'chat', label: 'Chat' },
  { id: 'progress', label: 'Story progress' },
  { id: 'captures', label: 'Compendium' },
  { id: 'learn', label: 'Research' },
  { id: 'names', label: 'Names' },
];

export default function RightPanelSwitcher({
  activeId,
  includeChat = true,
  namesEnabled = true,
  referenceEnabled = true,
  progressEnabled = true,
  onSelect,
}) {
  const choices = RIGHT_SLOT_CHOICES.filter((choice) => includeChat || choice.id !== 'chat');

  return (
    <div className="right-slot__switcher" role="toolbar" aria-label="Right panel">
      {choices.map((choice) => {
        const placeholder = Boolean(choice.placeholder);
        const needsReference = choice.id === 'captures' || choice.id === 'learn';
        const disabled = placeholder
          || (choice.id === 'progress' && !progressEnabled)
          || (choice.id === 'names' && !namesEnabled)
          || (needsReference && !referenceEnabled);
        const pressed = !disabled && activeId === choice.id;
        return (
          <button
            key={choice.id}
            type="button"
            className={[
              'right-slot__choice',
              pressed ? 'right-slot__choice--active' : '',
              placeholder ? 'right-slot__choice--placeholder' : '',
            ].filter(Boolean).join(' ')}
            aria-pressed={disabled ? undefined : pressed}
            disabled={disabled}
            aria-label={choice.label}
            title={choice.label}
            data-testid={`right-slot-${choice.id}`}
            onClick={() => {
              if (!disabled) onSelect?.(choice.id);
            }}
          >
            {choice.label}
          </button>
        );
      })}
    </div>
  );
}
